/**
 * @author: Wangwei
 * @description: 打卡营详情页 banner 滚动组件
 */
import { useRequest, useParams, Helmet } from 'umi';
import React, { useState, useEffect } from 'react';
import styles from './css/seamlessScroll.CSS.less';
import ReactSeamlessScroll, { SeamlessScrollProps } from 'rc-seamless-scroll';
import { getShowLog } from '@/utils/requests/camp/requests_details';
import { showLogType } from '@/types/camp/details/showLogType';

interface props {
  // 报名id
  batchId?: string | null;
}

const CampSeamlessScroll: React.FC<props> = ({ batchId }) => {
  const [listData, setListData] = useState<[showLogType] | null>(null);
  // 获取展示打卡记录
  const { run: getShowLogRequest } = useRequest(
    (batchId) => {
      return getShowLog(batchId);
    },
    {
      refreshDeps: [batchId],
      manual: true,
      onSuccess: (res) => {
        setListData(res);
      },
    },
  );

  useEffect(() => {
    getShowLogRequest(batchId);
  }, [batchId]);

  return (
    <>
      {Array.isArray(listData) && listData?.length > 0 && (
        <div className={styles.camp_details_wheel_box}>
          <ReactSeamlessScroll<SeamlessScrollProps>
            list={listData}
            wrapperHeight={160}
            step={0.5}
            hover
          >
            {listData.map((item, index) => (
              <div className={styles.wheel_list_box} key={index}>
                <span className="col808 com_ws_no">{item.username}</span>
                <span className="col172">{item.uid ? '领取了奖励' : '完成了'}</span>
                {item.uid ? (
                  <span className="colff3">{item.rewardName}</span>
                ) : (
                  <span className="col008">{item.nodeName}</span>
                )}
              </div>
            ))}
          </ReactSeamlessScroll>
        </div>
      )}
    </>
  );
};
export default CampSeamlessScroll;
